import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"contact-phone",attrs:{"href":"tel:+420 800 314 314"}},[_c('div',{staticClass:"contact-phone--content"},[_c('strong',[_vm._v(_vm._s(_vm.$t('contacts.phone')))]),_c('span',[_vm._v(_vm._s(_vm.$t('contacts.openingHours')))])]),_c(VIcon,{staticClass:"contact-phone--icon",class:[_vm.$vuetify.breakpoint.xsOnly ? 'ml-1' : 'ml-2'],attrs:{"color":"white","size":_vm.$vuetify.breakpoint.xsOnly ? 38 : 48}},[_vm._v(" mdi-phone ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }